import useDebounce from "helpers/useDebounce";
import { useEffect, useMemo, useState } from "react";

export default function useResizeObserver(ref: HTMLElement | undefined, delay = 100) {
  const [width, setWidth] = useState<number>(0);
  const [height, setHeight] = useState<number>(0);

  const debouncedWidth = useDebounce(width, delay);
  const debouncedHeight = useDebounce(height, delay);

  const observer = useMemo(
    () =>
      new ResizeObserver((entries) => {
        const firstEntry = entries[0];
        if (firstEntry) {
          setWidth(firstEntry.contentRect.width);
          setHeight(firstEntry.contentRect.height);
        }
      }),
    []
  );

  useEffect(() => {
    if (ref) {
      observer.observe(ref);
    }

    return () => {
      observer.disconnect();
    };
  }, [ref, observer]);

  return { width: debouncedWidth, height: debouncedHeight };
}
